import React, { forwardRef } from 'react';
import { TimesIcon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';
import IconButton from '../IconButton';
import { ICON_COLORS, ICON_SIZES } from '../shared/constants';
import type { TimesButtonProps } from './types';

const TimesButton = forwardRef<HTMLButtonElement, TimesButtonProps>(
  (
    {
      size = 'md',
      theme = 'dark',
      shape = 'square',
      onClick,
      dataTestId,
      className,
      ariaLabel,
      variant = 'ghost',
      disabled,
      dataTrackTag = 'times_button',
      ...rest
    },
    ref
  ) => {
    const getIconColor = () => {
      if (variant === 'filled') {
        return theme === 'dark' ? 'light' : 'dark';
      }

      return theme;
    };

    return (
      <IconButton
        ref={ref}
        aria-label={ariaLabel || translate<string>('button.closeButton.close')}
        variant={variant}
        shape={shape}
        size={size}
        intent="primary"
        onClick={onClick}
        data-testid={dataTestId}
        className={className}
        colorScheme={theme === 'light' ? 'white' : undefined}
        dataTrackTag={dataTrackTag}
        {...rest}
      >
        <TimesIcon size={ICON_SIZES[size]} color={disabled ? undefined : ICON_COLORS[getIconColor()]} />
      </IconButton>
    );
  }
);

TimesButton.displayName = 'TimesButton';

export default TimesButton;
